import React, { FC } from 'react';

type CarotRightProps = {
  /** The color of the icon. */
  color?: string;
};

const CarotRight: FC<CarotRightProps> = ({ color = 'currentColor' }) => (
  <svg height="100%" version="1.1" viewBox="0 0 12 22" width="100%">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill={color} fillRule="nonzero" transform="translate(-1.000000, -1.000000)">
        <path d="M1.992188,0.992188 C1.582031,0.992188 1.21875,1.238281 1.0625,1.613281 C0.910156,1.992188 1,2.421875 1.292969,2.707031 L10.585938,12 L1.292969,21.292969 C1.03125,21.542969 0.925781,21.917969 1.019531,22.265625 C1.109375,22.617188 1.382812,22.890625 1.734375,22.980469 C2.082031,23.074219 2.457031,22.96875 2.707031,22.707031 L12.707031,12.707031 C13.097656,12.316406 13.097656,11.683594 12.707031,11.292969 L2.707031,1.292969 C2.519531,1.097656 2.261719,0.992188 1.992188,0.992188 Z" />
      </g>
    </g>
  </svg>
);

export default CarotRight;
